const SITE_LOCALES = new Set(['en', 'zh', 'ja', 'ko', 'es', 'pt'])
const SITE_LOCALE_STORAGE_KEY = 'visual-game.locale'

export function initialSiteLocale(envLocale, storage = globalThis.localStorage, search = globalThis.location?.search || '', browserLocales = globalThis.navigator?.languages || []) {
  const requestedLocale = readRequestedLocale(search)
  if (requestedLocale) return requestedLocale
  const storedLocale = readStoredLocale(storage)
  if (storedLocale) return storedLocale
  if (envLocale === 'pt-BR') return 'pt'
  if (SITE_LOCALES.has(envLocale)) return envLocale
  return readBrowserLocale(browserLocales) || 'en'
}

// 首次访问按浏览器语言偏好顺序取第一个支持的语言；zh-TW、pt-BR 这类地区变体按主语言匹配
function readBrowserLocale(browserLocales) {
  for (const tag of browserLocales) {
    const language = tag.toLowerCase().split('-')[0]
    if (SITE_LOCALES.has(language)) return language
  }
  return ''
}

function readRequestedLocale(search) {
  const value = new URLSearchParams(search).get('locale')
  if (value === 'zh-CN') return 'zh'
  return SITE_LOCALES.has(value) ? value : ''
}

export function createSiteI18nRuntime(runtime, documentElement = globalThis.document?.documentElement, storage = globalThis.localStorage) {
  const baseSetLocale = runtime.setLocale
  const locales = runtime.locales.filter(item => SITE_LOCALES.has(item.code))

  async function setLocale(code) {
    if (!SITE_LOCALES.has(code)) throw new Error(`Unsupported visual-game locale: ${code}`)
    storage.setItem(SITE_LOCALE_STORAGE_KEY, code)
    await baseSetLocale(code)
    documentElement.lang = runtime.getLocale()
  }

  const ready = runtime.ready.then(() => { documentElement.lang = runtime.getLocale() })
  return { ...runtime, ready, locales, setLocale }
}

function readStoredLocale(storage) {
  const value = storage.getItem(SITE_LOCALE_STORAGE_KEY)
  if (value === 'pt-BR') return 'pt'
  return SITE_LOCALES.has(value) ? value : ''
}
